// extracted by mini-css-extract-plugin
export default {"inputsContainer":"BaseForm_inputsContainer__RNd2U","inputHalfWidth":"BaseForm_inputHalfWidth__8sRz3","formWrapper":"BaseForm_formWrapper__-oyVu"};